/* import __COLOCATED_TEMPLATE__ from './errors.hbs'; */
import Component from '@glimmer/component';

import { FourthlineErrorsFraud } from 'register-partners-js/react/components/fourthline/errors/fraud';
import { QesError } from 'register-partners-js/react/components/fourthline/errors/qes';

export default class ErrorComponent extends Component {
  qesError = QesError;
  fourthlineErrorsFraud = FourthlineErrorsFraud;

  get errorView(): string | undefined {
    //@ts-expect-error -- No types available for kyc yet
    if (!this.args.kyc) return;

    //@ts-expect-error -- No types available for kyc yet
    let { reason, providerStatus } = this.args.kyc;

    // Reason fraud list can be found here: https://dx.fourthline.com/docs/idv-statuses
    if (reason > 4000 && reason < 6000 && ![4110, 4111, 4112, 4160].includes(reason)) {
      return 'fraud';
    } else if (providerStatus === 'qes_required') {
      return 'qes';
    }
  }
}
